import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FroalaTextEditor } from 'components/UIElements'

const HEADERS = {
  header1: 'left_header',
  header2: 'center_header',
  header3: 'right_header',
}

const FOOTERS = {
  footer1: 'left_footer',
  footer2: 'center_footer',
}
function HeaderFooterFields(props) {
  const { consent, disabled, updateConsentElement } = props

  const onChangeTextValue = (value, elementKey) => {
    updateConsentElement({ elementKey, value })
  }

  const getItemValue = elementKey => {
    return consent.consent_elements[elementKey] ?? ''
  }

  return (
    <div className='header-footer-fields'>
      <h5>Header</h5>
      {Object.values(HEADERS).map((elementKey, idx) => {
        return (
          <div key={elementKey} id={`element_${elementKey}`}>
            <p className='label-small'>{`Header ${idx + 1}`}</p>
            <FroalaTextEditor
              value={getItemValue(elementKey)}
              onChange={newHtmlValue => onChangeTextValue(newHtmlValue, elementKey)}
              readOnly={disabled}
              moreText={{
                buttons: ['bold', 'italic', 'underline'],
                includeAll: false,
              }}
              charLimit={100}
            />
          </div>
        )
      })}
      <h5>Footer</h5>
      {Object.values(FOOTERS).map((elementKey, idx) => {
        return (
          <div key={elementKey} id={`element_${elementKey}`}>
            <p className='label-small'>{`Footer ${idx + 1}`}</p>
            <FroalaTextEditor
              value={getItemValue(elementKey)}
              onChange={newHtmlValue => onChangeTextValue(newHtmlValue, elementKey)}
              readOnly={disabled}
              moreText={{
                buttons: ['bold', 'italic', 'underline'],
                includeAll: false,
              }}
              charLimit={100}
            />
          </div>
        )
      })}
      <h5>Page number</h5>
      <p className='label-small'>page numbers will be available at the lower right corner of this document.</p>
    </div>
  )
}

HeaderFooterFields.propTypes = {
  consent: PropTypes.object,
  disabled: PropTypes.bool,
  updateConsentElement: PropTypes.func,
}

export default HeaderFooterFields
